import { useCallback, useContext } from 'react';
import { FilterContext } from 'components/filter/filters-next/FilterContext';
import { useGetMutableValues } from 'components/filter/filters-next/useGetMutableValues';
import { useUpdateFiltersByResource } from 'components/filter/useUpdateFiltersByResource';

const useDeleteFilter = () => {
    const { nodeId } = useContext(FilterContext);
    const getMutableValues = useGetMutableValues();
    const updateFiltersByResource = useUpdateFiltersByResource();

    return useCallback(() => {
        const mutableValues = getMutableValues();
        const index = mutableValues.filters.findIndex(v => v.id === nodeId);
        if (index !== -1) {
            mutableValues.filters.splice(index, 1);
            updateFiltersByResource(mutableValues);
        }
    }, [getMutableValues, nodeId, updateFiltersByResource]);
};

export { useDeleteFilter };
